import EditorField from './Editors/EditorField';
import './styles/DashboardField.scoped.scss';
import { useAct } from 'DashboardBuilder/store';
import NameEditor from './Editors/NameEditor';
import SourceSelector from './Editors/SourceSelector';

export default function DashboardField ({ id }) {
  const act = useAct();
  const field = useSel(s => s.dashboardFields.entities[id]);

  const setSource = (source) => {
    if (field.source !== source) {
      // clear other properties when source changes
      act.dashboardFields.upsert(field.id, {
        source: source,
        column: null,
        customFieldId: null,
        goalId: null,
        searchId: null,
        questionId: null,
        subscriptionTopics: null,
        organisationKind: null,
        config: {}
      });
    }
  }

  const update = (changes) => {
    act.dashboardFields.upsert(field.id, changes);
  }

  const setName = (name) => {
    act.dashboardFields.setName(field.id, name);
  }

  const remove = () => {
    act.dashboardFields.markInactive(field.id);
  }

  const memoEditorField = useMemo(() => {
    if (!field?.source) {
      return <></>
    }
    return <EditorField field={field} onChange={update} />;
  }, [field]);

  return (
    <>
      <div className='editor-header'>
        <div className="name">
          <NameEditor name={field.name} onChange={(newName) => setName(newName)} />
        </div>
        <div className="delete">
          <span className="delete-icon" onClick={remove}><SvgIconsDelete color="#8c8c9b" /></span>
        </div>
      </div>
      <div className="editor-content">
        <SourceSelector field={field} sourceSelected={setSource} />
        {memoEditorField}
      </div>
    </>
  );
};
